import { ISampleDevelopmentPl } from '../../models/sampleDevelopmentPl.model';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_SAMPLE_DEVELOPMENT_PL,
  CREATE_SAMPLE_DEVELOPMENT_PL,
  FETCH_SAMPLE_DEVELOPMENT_PL,
  FETCH_SAMPLE_DEVELOPMENT_PL_LIST,
  SUBMIT_SAMPLE_DEVELOPMENT_PL_FOR_APPROVAL,
  UPDATE_SAMPLE_DEVELOPMENT_PL,
} from './sampleDevelopmentPl.actions';
import { SampleDevelopmentPlState } from './sampleDevelopmentPl.types';

const initialState: SampleDevelopmentPlState = {
  errorMessage: '',
  item: {} as Readonly<ISampleDevelopmentPl>,
  items: [] as ISampleDevelopmentPl[],
  loading: false,
  totalItems: 0,
};

export default (
  state: SampleDevelopmentPlState = initialState,
  action: AppAction,
): SampleDevelopmentPlState => {
  switch (action.type) {
    case REQUEST(FETCH_SAMPLE_DEVELOPMENT_PL_LIST):
    case REQUEST(FETCH_SAMPLE_DEVELOPMENT_PL):
    case REQUEST(CREATE_SAMPLE_DEVELOPMENT_PL):
    case REQUEST(UPDATE_SAMPLE_DEVELOPMENT_PL):
      return { ...state, loading: true };
    case SUCCESS(FETCH_SAMPLE_DEVELOPMENT_PL_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_SAMPLE_DEVELOPMENT_PL_LIST):
    case FAILURE(FETCH_SAMPLE_DEVELOPMENT_PL):
    case FAILURE(CREATE_SAMPLE_DEVELOPMENT_PL):
    case FAILURE(UPDATE_SAMPLE_DEVELOPMENT_PL):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case SUCCESS(UPDATE_SAMPLE_DEVELOPMENT_PL):
    case SUCCESS(FETCH_SAMPLE_DEVELOPMENT_PL):
    case SUCCESS(CREATE_SAMPLE_DEVELOPMENT_PL):
    case SUCCESS(SUBMIT_SAMPLE_DEVELOPMENT_PL_FOR_APPROVAL):
      return { ...state, loading: false, item: action.payload.data };
    case CLEAR_SAMPLE_DEVELOPMENT_PL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
